// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "image-3Jfcy";
export { _1 as "__esModule", _2 as "image" }
export default { "__esModule": _1, "image": _2 }
